import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
var EXPERIMENTS_KEY = 'APT_EXPERIMENTS';
/** if the local storage flag with matching name is enabled, renders experiment instead of children
 *
 * LocalStorage key = APT_EXPERIMENT
 * LocalStorage value = comma separated experiment names
 * */
var ExperimentComponent = function (_a) {
    var name = _a.name, Experiment = _a.Experiment;
    var experiments = (localStorage.getItem(EXPERIMENTS_KEY) || '')
        .split(',')
        .map(function (experiment) {
        if (experiment === void 0) { experiment = ''; }
        return experiment.trim();
    });
    if (experiments.includes(name)) {
        return Experiment;
    }
    return _jsx(_Fragment, {});
};
export default ExperimentComponent;
